import runIcon from '@js/components/icons/runIcon';
import hikeIcon from '@js/components/icons/hikeIcon';
import bicycleIcon from '@js/components/icons/bicycleIcon';
import walkIcon from '@js/components/icons/walkIcon';
import bikeIcon from '@js/components/icons/bikeIcon';
import carIcon from '@js/components/icons/carIcon';
import cityIcon from '@js/components/icons/cityIcon';
import mapMarkerIcon from '@js/components/icons/mapMarkerIcon';
import mapMarkerRadiusIcon from '@js/components/icons/mapMarkerRadiusIcon';
import peakIcon from '@js/components/icons/peakIcon';

export const RIDE_TYPE_ICON = {
    running: runIcon,
    hiking: hikeIcon,
    bike: bicycleIcon,
    walk: walkIcon
};

export const ROUTE_TYPE_ICON = {
    foot: runIcon,
    hike: hikeIcon,
    bike: bikeIcon,
    mtb: bicycleIcon,
    car: carIcon
};

export const PLACE_ICON = {
    place: cityIcon,
    address: mapMarkerIcon,
    poi: mapMarkerRadiusIcon,
    peak: peakIcon,
    other: mapMarkerRadiusIcon
};
